import { render, staticRenderFns } from "./questionsAnswers.vue?vue&type=template&id=54e089ba&scoped=true&"
import script from "./questionsAnswers.vue?vue&type=script&lang=js&"
export * from "./questionsAnswers.vue?vue&type=script&lang=js&"
import style0 from "./questionsAnswers.vue?vue&type=style&index=0&id=54e089ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e089ba",
  null
  
)

export default component.exports